import { Record } from 'immutable';

const RoomTypeRateSummaryRecord = Record({
  roomType: null,
  roomRate: null,
  totalNights: 0,
  totalRevenue: 0,
  totalCommission: 0

});

export class RoomTypeRateSummary extends RoomTypeRateSummaryRecord {
  roomType: string;
  roomRate: number;
  totalNights: number;
  totalCommission: number;
  totalRevenue: number;
}

/**
 * RoomTypeRateSummary has multiple fields
 * This method defines sort algorithm for List<RoomTypeRateSummary>
 *
 * 1. Sort by room type. e.g king, queen, etc
 * 2. If room types are equal:
 *    - Sort by room rate
 *
 * Returns a number bc that is what is used for immutable-js list sort
 *
 * immutable-js List sort()
 * https://facebook.github.io/immutable-js/docs/#/List/sort
 *
 * @param a {RoomTypeRateSummary}
 * @param b {RoomTypeRateSummary}
 * @returns number
 */
export const RoomTypeRateSummarySort = (a: RoomTypeRateSummary, b: RoomTypeRateSummary): number => {

  let aRoomType = a.roomType ? a.roomType : '';
  let otherRoomType = b.roomType ? b.roomType : '';
  // check if roomType is equal
  let result = aRoomType.localeCompare(otherRoomType);
  if (result !== 0) {
    return result;
  }

  // fallback: sort by roomRate and cast to number for
  // immutable-js sort
  return a.roomRate < b.roomRate ? -1 : 1;
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/room-type-rate-summary.ts